import React from "react";
import Slider from "react-slick";

export const Permis = (props) => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
    };
  return (
    <div id="permis" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Permis</h2>
        </div>
        <div className="row">
          {props.data
            ? <>
                  <Slider {...settings} className="visible-lg">
                  {props.data.map((d, i) => (
                    <div key={`${d.title}-${i}`} className="item-permis">
                          {" "}
                            <a href={d.file} target="_blank" rel="noreferrer" className="text-center">
                                <img src={d.icon} alt={"Logo " + d.title} height={100} />
                            </a>
                          <h3>
                              <a href={d.file} target="_blank" rel="noreferrer" className="slick-list-element">{d.title}</a>
                          </h3>
                        <a
                            href={d.file} target="_blank"
                            className="btn btn-custom"
                            rel="noreferrer"
                        >
                            En savoir plus
                        </a>{" "}
                    </div>
                  ))}
                  </Slider>
                  <div className="visible-md visible-sm visible-xs">
                      {props.data.map((d, i) => (
                          <div key={`${d.title}-${i}`} className="item-permis col-md-4 col-sm-6">
                              {" "}
                              <a href={d.file} target="_blank" rel="noreferrer">
                                  <img src={d.icon} alt={"Logo " + d.title} height={100} />
                              </a>
                              <h3>
                                  <a href={d.file} target="_blank" rel="noreferrer" className="slick-list-element">{d.title}</a>
                              </h3>
                              <a
                                  href={d.file} target="_blank"
                                  className="btn btn-custom"
                                  rel="noreferrer"
                              >
                                  En savoir plus
                              </a>{" "}
                          </div>
                      ))}
                  </div>
              </>
            : "Chargement..."}
        </div>
      </div>
    </div>
  );
};
